<template>
  <div>
    <main>
      <Banner />
      <PdkHeader />
      <div class="select-business">
        <div class="selected-item">کسب و کار انتخاب شده</div>

        <div class="select" v-if="checkSources">
          <select
            class="select-text"
            style=" padding: 5px 18px"
            v-model="selectedSource"
            @change="onChange($event)"
          >
            <option
              v-for="(item, index) in sources"
              :value="{ id: item.id, name: item.name }"
              :key="index"
            >
              {{ item.name }}
            </option>
          </select>
          <span class="select-highlight"></span>
          <span class="select-bar"></span>
        </div>
      </div>

      <PdkSideMenu :menuList="menuList" />
    </main>
    <PdkFooter />
  </div>
</template>


<script>
import Banner from "@/components/tour/TourBanner";
import PdkHeader from "@/components/shared/PdkSubHeader";
import PdkFooter from "@/components/shared/PdkSubFooter";
import PdkSideMenu from "@/components/shared/PdkSideMenu";
import store from "../store/index";

export default {
  name: "Profile",
  store: store,
  data: function () {
    return {
      tabIndex: 0,
      profileId: "",
      sources: [],
      selectedSource: "",
      profileAccessibility: [],
      menuList: [],
    };
  },
  components: { PdkHeader, Banner, PdkFooter, PdkSideMenu },
  computed: {
    checkSources() {
      this.sources = this.$store.getters.GetAllSourceConfirmed;

      if (this.sources.length != 0) {
        const select = {
          id: this.sources[0].id,
          name: this.sources[0].name,
        };
        this.selectedSource = select;
      }

      return this.sources;
    },
  },
  mounted: () => {
    // document.querySelector("header").classList.add("sticky");
  },
  created() {
    this.getAccessibility();
  },
  methods: {
    async checkSources1() {
      this.sources = this.$store.getters.GetAllSourceConfirmed;

      if (this.sources.length != 0) {
        const select = {
          id: this.sources[0].id,
          name: this.sources[0].name,
        };
        this.selectedSource = select;
      } else {
        this.getAllSource();
      }
    },
    async getAllSource() {
      await this.$store.dispatch("getUserId").then(() => {
        this.profileId = this.$store.getters.GetUserId;

        this.sources = this.$store.getters.getAllSourceConfirmed;
        // this.$store
        //   .dispatch("getAllSourceConfirmed", this.profileId)
        //   .then((res) => {
        //     this.sources = res;

        //     if (this.sources != null) {
        //       const select = {
        //         id: this.sources[0].id,
        //         name: this.sources[0].name,
        //       };
        //       this.selectedSource = select;

        //       //this.getDepositInCrs();
        //     }
        //   });
      });
    },

    getDepositInCrs() {
      this.$store.dispatch("getDepositInCrs", this.sources[0].id);
    },
    onChange(event) {
      this.$store.commit("SetSourceIdInReport", this.selectedSource.id);
      this.$store.commit(
        "SetSelectedSourceCredit",
        this.sources.filter((p) => p.id == this.selectedSource.id)[0].credit
      );
      this.$store.commit(
        "SetSelectedSourceDeposit",
        this.sources.filter((p) => p.id == this.selectedSource.id)[0].deposit
      );
      if (this.$route.name != "dashboard")
        this.$router.push("/profile/dashboard");
    },
    getAccessibility() {
      this.menuList = JSON.parse(localStorage.getItem("menuList"));
    
      if (this.menuList.length != 0) {
        this.menuList = this.menuList.filter(
          (p) => p.name === "profile"
        )[0].children;
        this.menuList.sort(function (a, b) {
          return a.sortId - b.sortId;
        });
      }

      return this.menuList;
    },
  },
};
</script>

<style scoped >
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.margin_60 {
  padding-top: 60px;
  padding-bottom: 60px;
}
ul#cat_nav li a {
  position: relative;
  color: #777;
}
ul#cat_nav li a:after {
  font-family: fontello;
  content: "";
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 13px !important;
}
/* .selected-item {
  background: #d5ac40;
  color: #fff;
  font-size: 13px;
  text-align: center;
  padding: 2px;
  border-radius: 3px;
} */
.router-link-exact-active {
  /* color: #111  !important; */
  color: #08446a !important;
}

.score-management {
  background-color: #ededed;
  color: black;
}
.progress-box {
  background-color: lightgrey;
  width: 90%;
  /* width: 320px; */
  height: 5px;
}
.progress-bar {
  height: 5px;
}
.progress-bar1 {
  background-color: green;
  width: 60% !important;
}
.progress-bar2 {
  background-color: fuchsia;
  width: 70px !important;
}
.progress-bar3 {
  background-color: blue;
  width: 100px !important;
}
.bt-3 {
  margin-top: 2rem !important;
}
/* ********** leftside cards style : end ********** */
.router-link-active {
  position: relative;
}
</style>
